import { ReferenceLineStyle } from '@neptune/stroke-patterns-domain';

export type ReferenceLineConfig = {
  name: string;
  value?: number;
  color: string;
  style: ReferenceLineStyle;
  visible: boolean;
};

export type VisibleReferenceLineConfig = Required<ReferenceLineConfig> & {
  value: number;
  visible: true;
};

export type ReferenceLineConfigById = Record<string, ReferenceLineConfig>;

const DEFAULT_REFERENCE_LINE_NAME_PREFIX = 'Ref line';
const UNNAMED_REFERENCE_LINE_DISPLAY_NAME = 'Ref Line';

/** The name shown in chart tooltips and labels. */
export function getReferenceLineDisplayName(name: string): string {
  return name || UNNAMED_REFERENCE_LINE_DISPLAY_NAME;
}

export function generateReferenceLineName(existingCount: number): string {
  return `${DEFAULT_REFERENCE_LINE_NAME_PREFIX} ${existingCount + 1}`;
}

export function generateDuplicateReferenceLineName(
  originalName: string,
  existingNames: string[],
): string {
  const baseName = `Copy of ${originalName}`;

  if (!existingNames.includes(baseName)) {
    return baseName;
  }

  const matchingNames = existingNames.filter(
    (name) => name === baseName || name.startsWith(`${baseName} (`),
  );
  const nextNumber = matchingNames.length + 1;

  return `${baseName} (${nextNumber})`;
}

export const DEFAULT_REFERENCE_LINE_CONFIG: ReferenceLineConfig = {
  name: '',
  color: '#3B82F6',
  style: 'solid',
  visible: true,
};

export const REFERENCE_LINE_STYLE_OPTIONS = [
  { value: 'solid', label: 'Solid' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' },
];
